import { useCallback } from 'react';
import {
  platformCan,
  type Action,
  type PlatformRole,
  type PlatformSubject
} from '@bliks-io/contracts';
import { useProfileQuery } from '@/api/queries/useProfile';

const EMPTY: PlatformRole[] = [];

/**
 * Was dieser Mensch an der Plattform darf (ADR 0042).
 *
 * Aus dem Profil gelesen, nicht erfragt: die Rollen stehen am Benutzer, und
 * die Regeln dazu sind dieselbe Tabelle wie im Backend (`PLATFORM_ROLE_RULES`
 * in den Contracts). Solange das Profil lädt, darf nichts — die Navigation
 * baut sich auf, wenn die Antwort da ist, statt kurz alles zu zeigen und dann
 * einzuklappen.
 *
 * Gezeigt wird, was erlaubt ist; abgelehnt wird trotzdem am Server.
 */
export function usePlatformRoles() {
  const { data, isLoading } = useProfileQuery();
  const roles: PlatformRole[] = data?.data?.platformRoles ?? EMPTY;

  const can = useCallback(
    (action: Action, subject: PlatformSubject): boolean => platformCan(roles, action, subject),
    [roles]
  );

  return { roles, can, isLoading };
}
